import { Box, Container, Heading, Stack } from '@spaceship-fspl/components';
import { TrackingCategory } from '@spaceship-fspl/tracking';
import { PanelSection } from 'components';
import { AppAndPlayStores } from 'components/app-and-play-stores';
import appsDownloadImage from 'images/first-home_apps-download.svg';
import React from 'react';
import styled from 'styled-components';

export interface AppsDownloadPanelProps {
  title?: string | null;
  appStoreUrl?: string | null;
  playStoreUrl?: string | null;
}

export const AppsDownloadPanel: React.FC<AppsDownloadPanelProps> = ({
  title,
  appStoreUrl,
  playStoreUrl,
}) => {
  return (
    <TrackingCategory category="Apps Download Panel">
      <PanelSection
        backgroundColor="indigo.100"
        paddingBottom={{ xs: 'xl', md: 'xxl', lg: 'none' }}
      >
        <Container>
          <Stack spaceY="xl" alignX="center">
            <Stack spaceY={{ xs: 'lg', lg: 'xl' }}>
              <Heading
                component="h2"
                variant={2}
                color="neutral.000"
                align="center"
              >
                {title}
              </Heading>

              <AppAndPlayStores
                appStoreUrl={appStoreUrl}
                playStoreUrl={playStoreUrl}
                variant="light"
              />
            </Stack>

            <Box height={{ lg: 300 }} width={{ lg: 625 }} overflow="hidden">
              <StyledAppsDownloadImg
                src={appsDownloadImage}
                alt={title ?? ''}
              />
            </Box>
          </Stack>
        </Container>
      </PanelSection>
    </TrackingCategory>
  );
};

const StyledAppsDownloadImg = styled.img`
  width: 100%;
`;
